import React, { useContext } from 'react';

import './Skills.css';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Pagination, Navigation } from "swiper/modules";

import { ThemeContext } from '../../contexts/ThemeContext';
import { skillsData } from '../../data/skillsData';
import { skillsImage } from '../../utils/skillsImage';

function Skills() {

    const { theme } = useContext(ThemeContext);

    const skillBoxStyle = {
        backgroundColor: theme.secondary,
        boxShadow: `0px 0px 12px ${theme.primary}`
    }

    return (
        <div className="skills" style={{ backgroundColor: theme.secondary }}>
            <div className="skillsHeader">
                <h2 style={{ color: theme.primary }}>Skills</h2>
            </div>
            <div className="skillsContainer">
                <div className="skill--scroll">





                <Swiper
                    className="mySwiper w-full"
                    spaceBetween={30}
                    speed={2000}
                    loop
                    freeMode= {true}
                    autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                        // pauseOnMouseEnter: true,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        200: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        },
                        400: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        },
                        768: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                        },
                        1024: {
                        slidesPerView: 6,
                        spaceBetween: 50,
                        },
                    }}
                    modules={[Autoplay, Pagination, Navigation]}
                    >
                    {skillsData.map((skill, id) => (
                                        <SwiperSlide className="skill--box" key={id} style={skillBoxStyle}>
                                            <span className='flex justify-center'><img className='h-12' src={skillsImage(skill)} alt={skill} /></span>
                                            <h3 style={{ color: theme.tertiary }}>
                                                {skill}
                                            </h3>
                                        </SwiperSlide>
                                    ))}
                </Swiper>
                </div>
            </div>
        </div>
    )
}

export default Skills
